import i18n from 'app-i18n';
import * as yup from 'yup';

export const customersFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .max(100)
    .required()
    .flexDefault('')
    .emojisAreNotSupported(),
  lastName: yup
    .string()
    .max(100)
    .required()
    .flexDefault('')
    .emojisAreNotSupported(),
  email: yup.string().max(100).email().required().flexDefault(''),
  phoneNumber: yup.string().max(10).required().flexDefault(''),
  dateOfBirth: yup
    .string()
    .flexDefault('')
    .test(
      'dob',
      () => i18n.t('page.customers.form.customer.dobError'),
      value => {
        const febRegex = /^02-(0[1-9]|1[0-9]|2[0-9])$/;
        const thirtyDayMonthsRegex = /^(04|06|09|11)-(0[1-9]|[12][0-9]|30)$/;
        const thirtyOneDayMonthsRegex =
          /^(01|03|05|07|08|10|12)-(0[1-9]|[12][0-9]|3[01])$/;

        return (
          !value ||
          febRegex.test(value) ||
          thirtyDayMonthsRegex.test(value) ||
          thirtyOneDayMonthsRegex.test(value)
        );
      },
    ),
});
